import FieldWrapper from '../Field-wrapper';

import { QRCode } from '$HVUI';
import { fieldDisplayValue } from '$Utils';

import '../Fields.module.less';
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
const QRCodeFieldInput = props => {
    const {
        name,
        value = '', //prevents uncontrolled input warning
        style
    } = props;

    const displayValue = fieldDisplayValue(props);

    return (
        <div style={style}>
            <QRCode
                displayValue={value}
                style={{
                    width: '60vw',
                    height: '60vw',
                    maxWidth: '300px',
                    maxHeight: '300px',
                    margin: 'auto',
                    display: 'block',
                    padding: '16px',
                    border: '16px solid #000',
                    borderRadius: '8px'
                }}
                value={`{"id":"${value}"}`}
            />
            <input id={name} type="hidden" name={name} value={value} />
        </div>
    );
};
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export default FieldWrapper(QRCodeFieldInput, { reduxForm: true });
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export const QRCodeField = FieldWrapper(QRCodeFieldInput);
